import { Edit2, Link, Share2, Tag, Trash2 } from "react-feather";
import { H5, LI, P, UL } from "../../../../../AbstractElements";
import { Href } from "../../../../../Constants/Constants";
import { DescriptionBookMarkPropsType } from "../../../../../Types/BookmarkType";

const DescriptionData: React.FC<DescriptionBookMarkPropsType> = ({ data, onHandleClick, removeFromBookmark }) => {

  return (
    <div className="desciption-data">
      <div className="title-bookmark">
        <H5 className="title_0">{data.title}</H5>
        <P className="weburl_0">{data.website_url}</P>
        <div className="hover-block">
          <UL className="simple-list flex-row">
            <LI><a href={Href} onClick={() => onHandleClick(data)}><Edit2 /></a></LI>
            <LI><a href={Href}><Link /></a></LI>
            <LI><a href={Href}><Share2 /></a></LI>
            <LI><a href={Href} onClick={() => removeFromBookmark(data.id)}><Trash2 /></a></LI>
            <LI className="text-end"><a href={Href}><Tag /></a></LI>
          </UL>
        </div>
        <div className="content-general">
          <P className="desc_0">{data.desc}</P>
          <span className="collection_0">{data.collection}</span>
        </div>
      </div>
    </div>
  );
};

export default DescriptionData;
